import { gql } from '@apollo/client';
import unavailablePeriodFragment from '../unavailablePeriodFragment';

const GET_UNAVAILABLE_PERIODS = gql`
  query GetUnavailablePeriods($targetUser: Int) {
    unavailablePeriods(targetUser: $targetUser) {
      ...UnavailablePeriodFields
    }
  }
  ${unavailablePeriodFragment}
`;

export default GET_UNAVAILABLE_PERIODS;
